import type { TimeChip } from '@/features/scheduling/availability'
import { Button, ButtonText } from '@/ui/core/button'

/**
 * One bookable time: a white pill on the blush card, filled black when it is the chosen one.
 *
 * Forty points drawn, forty-four given. The height is set as a number because the button's own
 * `default` size says `min-h-11`, which reads as forty-four and is not: NativeWind sizes its
 * spacing scale off a fourteen point rem on native, so eleven units is thirty-eight and a half.
 *
 * The two points of slop above and below, and four either side, make up the difference between
 * what the card wants and what a finger is entitled to. Four is half the gap between one time
 * and the next, so no chip's target ever reaches its neighbour's.
 *
 * The fill is applied only while it is unchosen. Spelled out unconditionally it won the merge
 * against the selected compound's `bg-ink`, so choosing a time turned its label white on a white
 * pill and the time the patient had just picked left the row.
 */
export const TimeChipButton = ({
	chip,
	isSelected,
	onPress,
}: { chip: TimeChip; isSelected: boolean; onPress: () => void }) => (
	<Button
		variant="secondary"
		fullWidth={false}
		selected={isSelected}
		onPress={onPress}
		accessibilityLabel={chip.label}
		accessibilityState={{ selected: isSelected }}
		hitSlop={{ top: 2, bottom: 2, left: 4, right: 4 }}
		style={{ minHeight: 40 }}
		className={isSelected ? undefined : 'border-white bg-white'}
	>
		<ButtonText>{chip.label}</ButtonText>
	</Button>
)
